export default __webpack_public_path__ + "static/media/colocado-9-thumb.f896f64c.jpg";